import { render, staticRenderFns } from "./RemoveTalentPoolDialog.vue?vue&type=template&id=4dde626e&"
import script from "./RemoveTalentPoolDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveTalentPoolDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports